import { QueryClient } from "@tanstack/react-query";
import { ApiError, isDatabaseWaking } from "./client";

/** The database pauses after an hour idle and takes about a minute to resume; keep asking for up to 3 minutes. */
export const DATABASE_WAKING_RETRY_MS = 5_000;
const DATABASE_WAKING_MAX_RETRIES = 36;

export function createQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
          if (isDatabaseWaking(error)) return failureCount < DATABASE_WAKING_MAX_RETRIES;
          // Don't retry client errors (401/403/404/422…); retry network/5xx twice.
          if (error instanceof ApiError && error.status >= 400 && error.status < 500) return false;
          return failureCount < 2;
        },
        retryDelay: (attempt, error) =>
          isDatabaseWaking(error) ? DATABASE_WAKING_RETRY_MS : Math.min(1000 * 2 ** attempt, 30_000),
      },
      mutations: { retry: false },
    },
  });
}
